import RegisterForm from "@/components/RegisterForm";

export default function RegisterEnterprise() {
  return <RegisterForm role="enterprise" />;
}
